import React, { useState, useCallback, useMemo, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { useMsal } from '@azure/msal-react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import { MenuItem, Select } from '@mui/material';
import { formatToKOrM } from '../../../helper';
import ChartsForIF from '../GraphView/GraphViewIF_Overall/ChartsForIF';
import AlertService from '../../../services/console_services/Alerts';
import Loading from '../Loading';
import { Radio } from '@mui/material';

const useStyles = makeStyles({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '10vh',
        width: '100%',
        position: 'relative',
        top: 0,
        left: 0,
    },
    select: {
        borderColor: 'transparent',
        borderStyle: 'none',
        height: '30px',
        width: "120px",
        borderRadius: "4px !important",
        background: "var(--Neutral-Colors-White, #FFF)",
        fontSize: "14px !important",
        color: "#404041 !important",
        '&.MuiOutlinedInput-root': {
            margin: "0px 17px",
        },
    },
    selectContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px', // Adjust the spacing between the selects
        padding: '10px 20px', // Adjust padding as needed
    },
});

const networkOptions = [
    { entity: "Network", value: "AMBIENT" },
    { entity: "Network", value: "CHILLED" },
    { entity: "Network", value: "FROZEN" },
    { entity: "Network", value: "NPW" }
];

const BootstrapDialog = styled(Dialog)(({ _theme }) => ({
    '& .MuiDialog-paper': {
        width: '70%',
        maxWidth: 'none',
        minHeight: "300px",
        borderRadius: 12,
    },
}));

const AlertGraphPopUp = ({
    alertData,
    open,
    handleClose
}) => {
    const classes = useStyles();
    const { instance } = useMsal();
    // const { tabName } = useSelector((state) => state?.tabs);
    const [selectedNetwork, setSelectedNetwork] = useState("AMBIENT");
    const [alertGraphData, setAlertsGraphData] = useState([]);
    const [loading, setLoading] = useState(false);
    const dateRange = useSelector((state) => state?.filter?.Date);
    const role = useSelector((state) => state?.login?.role);
    const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
    const [countValue, setCountValue] = useState("5");
    const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 100];

    const radioOptions = () => {
        const optionsMap = ["Ambient", "Chilled"];
        return optionsMap || [];
    };
    const [selectedRadioValue, setSelectedRadioValue] = useState(radioOptions()[0]);

    const handleChangeNetwork = (event) => {
        setSelectedNetwork(event.target.value);
    };

    const handleRadioChange = (selectedFilter) => {
        setSelectedRadioValue(selectedFilter);
    };

    const getAlertGraphData = () => {
        setLoading(true);
        let params = {
            section: "IF",
            type: alertData?.Insight_Type,
            name: "Network",
            X_Axis: "Network",
            arrangements: "Top",
            value: "5",
            Level: role,
            filter: {
                Network: [selectedNetwork],
                startDate: dateRange?.[0],
                endDate: dateRange?.[1],
            },
        };
        AlertService.getAlertsInsightsChartData(params, instance).then(data => {
            if (data?.data) {
                setAlertsGraphData(data?.data);
            }
        })
            .catch(error => console.error('Error:', error))
            .finally(() => setLoading(false));
    };

    const getAlertGraphDataTM = () => {
        setLoading(true);
        let params = {
            "type": alertData?.Metric,
            "arrangements": topOrBottomValue,
            "X_Axis": selectedRadioValue,
            "value": countValue,
            "filter": {
                "RecommendedDC": [],
                "Network": ["AMBIENT"],
                "temperature": ["AMBIENT"]
            }
        };
        AlertService.getAlertsInsightsChartDataTM(params, instance).then(data => {
            if (data?.data) {
                setAlertsGraphData(data?.data);
            }
        })
            .catch(error => console.error('Error:', error))
            .finally(() => setLoading(false));
    };


    useEffect(() => {
        if (open) {
            if (alertData?.Module === 'TM') {
                getAlertGraphDataTM();
            } else {
                getAlertGraphData();
            }
        }
    }, [open, selectedNetwork]);



    const handleTopBottomChange = (event) => {
        setTopOrBottomValue(event.target.value);
    };


    const handleCountChange = (event) => {
        setCountValue(event.target.value);
    };
    // console.log(alertData, 'alertData');

    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >

            <DialogTitle sx={{ m: 0, padding: "10px 20px 0px 35px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{
                    display: "flex",
                    padding: "10px",
                    fontFamily: "Poppins, sans-serif",
                }}>
                    <div style={{
                        marginRight: "15px",
                        fontWeight: 800
                    }}>
                        ${formatToKOrM(alertData?.Impact_Value ? alertData?.Impact_Value : alertData?.Metric_value)}
                    </div>
                    <div style={{
                        marginLeft: "15px",
                    }}>
                        {alertData?.Impact_Value ? alertData?.Impact_Value : alertData?.Metric}
                    </div>
                </div>
                <div style={{
                    display: "flex",
                    padding: "10px",
                }}>
                    <div>
                        <Select
                            value={selectedNetwork}
                            onChange={handleChangeNetwork}
                            className={classes.select}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            sx={{ ...classes.select }}
                        >
                            {
                                networkOptions?.map((option) => {
                                    return (
                                        <MenuItem value={option?.value}>
                                            {option?.value}
                                        </MenuItem>
                                    );
                                })
                            }
                        </Select>
                    </div>
                    <div>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{ color: (theme) => theme.palette.grey[500] }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>

            </DialogTitle>
            {alertData?.Module === 'TM' &&
                <div className={classes.selectContainer}>
                    <Select
                        value={topOrBottomValue}
                        onChange={handleTopBottomChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                        <MenuItem value="Top">
                            Top
                        </MenuItem>
                        <MenuItem value={"Bottom"}>
                            Bottom
                        </MenuItem>
                    </Select>
                    <Select
                        value={countValue}
                        onChange={handleCountChange}
                        className={classes.select}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                        {countList.map((item, _index) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {radioOptions().map((option) => (
                            <React.Fragment key={option}>
                                <Radio
                                    value={option}
                                    checked={selectedRadioValue === option}
                                    onChange={() => handleRadioChange(option)}
                                    size="small"
                                    inputProps={{ 'aria-label': option }}
                                    sx={{
                                        color: "#359DD0 !important",
                                        '&.Mui-checked': {
                                            color: "#359DD0 !important",
                                        },
                                    }}
                                />
                                <span
                                    className={classes.filter}
                                    style={{
                                        color: "#359DD0"
                                    }}
                                >
                                    {option}
                                </span>

                            </React.Fragment>
                        ))}
                    </div>
                </div>
            }
            <DialogContent>
                {loading ?
                    <div className={classes.loader}>
                        <Loading />
                    </div>
                    :
                    <ChartsForIF
                        graphData={alertGraphData}
                        activeTab={alertData?.Module === 'TM' ? alertData?.Metric : "alert"}
                        type=""
                        showAnnotation={false}
                    />
                }
            </DialogContent>
        </BootstrapDialog>
    );
};
const mapStateToProps = state => ({
    tabIndex: state.tabs.index,
    Network: state.filter.Network,
    DC: state.filter.DC,
    Products: state.filter.Products,
    periodType: state.filter.periodType,
    PL3: state.filter.PL3,
    date: state.filter.Date,
    Division: state.filter.Division,
    applyFilter: state.filter.applyFilter,
    role: state.login.role,
});

export default connect(mapStateToProps)(AlertGraphPopUp);
